// extracted by mini-css-extract-plugin
export var copyableField = "_ng-4";
export var customerBadge = "_ng-0";
export var customerInfoTitle = "_ng-2";
export var details = "_ng-1";
export var dropdownContainer = "_ng-5";
export var dropdownImage = "_ng-6";
export var editAssigneeForm = "_ng-a";
export var editButton = "_ng-3";
export var email = "_ng-7";
export var hidden = "_ng-d";
export var input = "_ng-8";
export var saveButton = "_ng-b";
export var shopifyIcon = "_ng-c";
export var suggestionBadge = "_ng-e";
export var suggestionText = "_ng-f";
export var username = "_ng-9";